module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/logoWI_5A.cd4bbf05.svg";